"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { Button, NutcakeLongLogo } from "@drpcrd/shared/ui";
import { cn } from "@drpcrd/utils";

/**
 * Sticky top navigation for press release pages.
 * Transparent at the top; transitions to a white bar with the Nutcake logo once the user scrolls.
 */
export const PressPageNavbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      aria-label="Site navigation"
      className={cn(
        "fixed top-0 z-50 flex w-full items-center justify-between px-2 py-2 transition-all duration-300 motion-reduce:transition-none",
        scrolled ? "bg-white" : "bg-transparent",
      )}
    >
      <Link
        href="/"
        aria-label="Nutcake home"
        className="flex shrink-0 items-center"
      >
        <NutcakeLongLogo className="h-4 w-auto shrink-0 sm:h-5.25" />
      </Link>

      <div className="flex shrink-0 items-center gap-3">
        <Button
          as={Link}
          href="https://brand.creatoros.xyz/"
          target="_blank"
          rel="noopener noreferrer"
          variant="text"
          size="md"
          className="inline-flex font-semibold"
        >
          Sign in
        </Button>
        <Button as={Link} href="/contact" variant="filled">
          Start now
        </Button>
      </div>
    </header>
  );
};
